import React from "react";

const Headings = ({ title = "Title", subText = "Subtext" }) => {
    return (
        <div className="d-flex flex-column align-items-center ">
            <h5 className="auth-heading-text">{title}</h5>
            <p className="auth-sub-text">{subText}</p>
        </div>
    );
};

export default Headings;
